/**
 * Created by bosch22 on 13/6/18.
 */
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../globals';


//interface
interface Ingredient {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  stock_max: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  preparation: string;
  created_at: any;
}

/*interface Provider{
    default:boolean;
    name_static
}*/


@Injectable()
export class IngredientsServices {
  public firestore: any;
  public image_url_ingr_view: Observable<string | null>;
  ingredientsCol: AngularFirestoreCollection<Ingredient>;
  ingredientsCol_subrecipe: AngularFirestoreCollection<Ingredient>;
  ingredients: Observable<Ingredient[]>;
  ingredients_subrecipe: Observable<Ingredient[]>;
  ingredientDoc: AngularFirestoreDocument<Ingredient>;
  ingredient: Observable<Ingredient[]>;
  ingredients_variations: Observable<Ingredient[]>;
  ingredients_stock: Observable<Ingredient[]>;

  //TMP - Son variables a utilizar en diferentes puntos de la creacio/edicion para enviar modificar la informacion de diferentes componentes
  public foodcost_array_tmp: any = Array();
  public ingredient_tags = Array();
  public ingredient_allergens_tmp = Array();
  public ingredients_array_tmp = Array();
  public quick_create: boolean = false;
  public quick_create_type: boolean = false;
  public quick_create_dish: boolean = false;
  public quick_ingredient: any;
  public provider_ingredients_array_tmp = Array();

  public pagesIngredients: any;
  public page_active: number = 1;
  public limit_pages = 100;
  public first_ingredient_name: any = [];
  public get_ingredients_done: boolean = false;

  public _ingredients_array_tmp: any
  public ingredients_array: any

  public show_alert_delete: boolean = true;

  constructor(public afs: AngularFirestore,
    public http: HttpClient,
    public globals: Globals) {
    this.firestore = firebase.firestore();
  }

  getList(UID_RESTAURANT) {
    this.ingredientsCol = this.afs.collection('ingredients', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .orderBy('name', 'asc'));
    this.ingredients = this.ingredientsCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ingredient;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  getListSubrecipe(UID_RESTAURANT) {
    this.ingredientsCol_subrecipe = this.afs.collection('ingredients', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', true)
      .orderBy('name', 'asc'));
    this.ingredients_subrecipe = this.ingredientsCol_subrecipe.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ingredient;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  /*GET IN STOCK*/
  getListIngredientsBasic(UID_RESTAURANT) {
    this.ingredientsCol = this.afs.collection('ingredients', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .orderBy('name', 'asc')
      .limit(10));
    this.ingredients_stock = this.ingredientsCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ingredient;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  /*GET IN CONF. VARIATIONS*/
  getListIngredientsVariations(UID_RESTAURANT) {
    this.ingredientsCol = this.afs.collection('ingredients', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .orderBy('name', 'asc'));
    this.ingredients_variations = this.ingredientsCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ingredient;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  delete(uid) {
    this.afs.doc('ingredients/' + uid).delete();
  }

  async getIngredients(UID_RESTAURANT) {
    const ingredientsRef = this.firestore.collection('ingredients');

    var ingredients = [];

    await ingredientsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var ingredient = doc.data();
          ingredient.UID = doc.id;

          ingredients.push(ingredient);
        });
      });

    return ingredients
  }


  async getIngredientsBasic(UID_RESTAURANT) {
    const ingredientsRef = this.firestore.collection('ingredients');

    var ingredients = [];

    await ingredientsRef
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var ingredient = doc.data();
          ingredient.UID = doc.id;

          ingredients.push(ingredient);
        });
      });

    return ingredients
  }

  async getIngredientsCompostos(UID_RESTAURANT) {
    const ingredientsRef = this.firestore.collection('ingredients');

    var ingredients = [];

    await ingredientsRef
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', true)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var ingredient = doc.data();
          ingredient.UID = doc.id;

          ingredients.push(ingredient);
        });
      });

    return ingredients
  }

  async getIngredientsSubNoIncludeSubrecipe(UID_RESTAURANT) {
    const ingredientsRef = this.firestore.collection('ingredients');

    var ingredients = [];

    await ingredientsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', true)
      .where('ingredient_include_subrecipe', '==', false)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var ingredient = doc.data();
          ingredient.UID = doc.id;

          ingredients.push(ingredient);
        });
      });

    return ingredients
  }

  async getIngredientsSubIncludeSubrecipe(UID_RESTAURANT) {
    const ingredientsRef = this.firestore.collection('ingredients');

    var ingredients = [];

    await ingredientsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', true)
      .where('ingredient_include_subrecipe', '==', true)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var ingredient = doc.data();
          ingredient.UID = doc.id;

          ingredients.push(ingredient);
        });
      });

    return ingredients
  }

  async getIngredient(uid) {
    const ingRef = this.firestore.collection('ingredients').doc(uid);

    var _ingr;

    await ingRef.get().then(doc => {
      if (doc.exists) {
        _ingr = doc.data();
        _ingr.UID = doc.id;
      }
    });

    return _ingr

  }


  //FUNC CALCULATE//
  calculateWaste(waste, quantity) {
    var gross_quantity;
    var total_quantity;
    if (waste > 0) {
      gross_quantity = (quantity * waste) / 100;
      total_quantity = gross_quantity + quantity;
      return total_quantity;
    } else {
      total_quantity = quantity;
      return total_quantity;
    }

  }

  calculatePrice(price, total_quantity, measurement) {
    var price_ingr;
    if (measurement === 'kg' || measurement === 'l') {
      //kg l
      var price_grams = price / 1000;
      price_ingr = price_grams * total_quantity;
    } else {
      //units
      price_ingr = price * total_quantity;
    }
    return price_ingr;
  }

  measurementLite(measurement) {
    var _measurement;
    if (measurement === 'kg') {
      _measurement = 'gr';
    } else if (measurement === 'l') {
      _measurement = 'ml';
    } else {
      //units
      _measurement = 'ud';
    }
    return _measurement;


  }

  cleanArrayTmp() {
    this.foodcost_array_tmp = Array();
  }

  returnPricePerMeasurement(price, real_weight) {
    return parseFloat(price) / parseFloat(real_weight);
  }

  //PAGINATE
  async getPagesIngredientsProducts(elements_per_page) {
    this.get_ingredients_done = false;
    this.filteredIngredientsActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'get/ingredients_products', params, {})
      .subscribe(async res => {
        this._ingredients_array_tmp = res['list'];
        if (this._ingredients_array_tmp.length != 0) {
          this.getListIngredientsProductsMinMax();
        } else {
          this.filteredIngredientsActive = true;
        }
      });
  }
  getListIngredientsProductsMinMax() {
    this.get_ingredients_done = true;
    //Search for first element to start
    this.first_ingredient_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    if (this.limit_pages > 0) {
      this.ingredients_array = this._ingredients_array_tmp.slice(this.first_ingredient_name, this.first_ingredient_name + this.limit_pages);
    } else {
      this.ingredients_array = this._ingredients_array_tmp;
    }
  }


  public filteredIngredients: any;
  public filteredIngredientsActive: boolean = false;

  //PAGINATE
  async getPagesIngredients(type, elements_per_page) {
    this.get_ingredients_done = false;
    this.filteredIngredientsActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('type', type)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'paginate/ingredient', params, {})
      .subscribe(async res => {
        this.pagesIngredients = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.first_ingredient_name = res['first_ingredients_name'];
        this._ingredients_array_tmp = res['list_ingredients'];
        if (this.pagesIngredients != 0) { //Si no hay paginas
          this.getListIngredientsMinMax();
        } else {
          this.filteredIngredientsActive = true;
        }
      });
  }
  //FILTER
  searchIngredientNode(value, type) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredIngredientsActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('type', type)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'filter/ingredient', params, {})
          .subscribe(async res => {
            this.filteredIngredients = res;
            this.filteredIngredientsActive = true;
          });
      } else {
        this.filteredIngredientsActive = false;
      }
    }
  }

  first_element: any;

  getListIngredientsMinMax() {
    this.get_ingredients_done = true;

    //Ordenamos el array
    this._ingredients_array_tmp.sort((a, b) => a.name.localeCompare(b.name));

    //Search for first element to start
    this.first_element = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    if (this.limit_pages > 0) {
      this.ingredients_array = this._ingredients_array_tmp.slice(this.first_element, this.first_element + this.limit_pages);
    } else {
      this.ingredients_array = this._ingredients_array_tmp;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/services.ts